<h5 mat-dialog-title>Update Job Address</h5>
<div mat-dialog-content *ngIf="data">
  <form #statusForm="ngForm" (ngSubmit)="saveAddress(statusForm)">
    <div class="form-group row">
      <label fot="quote_Name" class="col-form-label">Name</label>
      <input type="text" name="quote_Name" id="quote_Name" class="form-control"
             [(ngModel)]="project.quote_Name" #quote_Name="ngModel" required />
      <div [hidden]="!statusForm.submitted || quote_Name.valid" class="alert alert-danger" i18n>Name is required</div>
    </div>
    <div class="form-group row">
      <label fot="quote_Address1" class="col-form-label">Address 1</label>
      <input type="text" name="quote_Address1" id="quote_Address1" class="form-control"
             [(ngModel)]="project.quote_Address1" #quote_Address1="ngModel" required />
      <div [hidden]="!statusForm.submitted || quote_Address1.valid" class="alert alert-danger" i18n>Address is required</div>
    </div>
    <div class="form-group row">
      <label fot="quote_Address2" class="col-form-label">Address 2</label>
      <input type="text" name="quote_Address2" id="quote_Address2" class="form-control"
             [(ngModel)]="project.quote_Address2" #quote_Address2="ngModel" />
    </div>
    <div class="form-group row">
      <label fot="quote_City" class="col-form-label">City</label>
      <input type="text" name="quote_City" id="quote_City" class="form-control"
             [(ngModel)]="project.quote_City" #quote_City="ngModel" required />
      <div [hidden]="!statusForm.submitted || quote_City.valid" class="alert alert-danger" i18n>City is required</div>
    </div>
    <div class="form-group row">
      <label fot="quote_State" class="col-form-label">State</label>
      <select name="quote_State" id="quote_State" class="form-control state-select select-bidit"
              [(ngModel)]="project.quote_State" #quote_State="ngModel" required>
        <option value="">-</option>
        <option *ngFor="let state of data.states;  let i=index" [(ngValue)]="data.states[i]">{{state}}</option>
      </select>
      <div [hidden]="!statusForm.submitted || quote_State.valid" class="alert alert-danger" i18n>State is required</div>
    </div>
    <div class="form-group row">
      <label fot="quote_Postal" class="col-form-label">Zip</label>
      <input type="text" name="quote_Postal" id="quote_Postal" class="form-control"
             [(ngModel)]="project.quote_Postal" #quote_Postal="ngModel" required />
      <div [hidden]="!statusForm.submitted || quote_Postal.valid" class="alert alert-danger" i18n>Zip is required</div>
    </div>
    <div class="form-group">
      <button mat-button type="submit" class="btn btn-bidit-submit mr-1">Submit</button>
      <button mat-button type="button" (click)="onNoClick()" class="btn btn-bidit-cancel">Cancel</button>
    </div>
  </form>
</div>
